import {Component, OnDestroy, OnInit, inject, HostListener} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/login/data-access/auth.service';
import {
  faBook,
  faBookOpen,
  faChevronDown, faChevronLeft,
  faClock,
  faFileAlt,
  faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";
import {StudentExam} from "../../dashboard/feature/studentDashboard/studentDashboard.component";
import {Course} from "../../admin/data-access/course.model";
import {StatusFormatterPipe} from "../../dashboard/feature/studentDashboard/statusFormatter.pipe";
import {Pagination} from "../../exam/feature/exam-submissions/exam-submissions.component";
import {getDaysRemaining} from "../../shared/utils/getDaysRemaining";
import {ExamService} from "../../exam/data-access/exam.service";

enum AssessmentTabs {
  open,
  past,
  practice
}

enum AssessmentTypes{
  all_types = 'All Types',
  exam = 'Exam',
  quiz = 'Quiz',
  homework = 'Homework',
}

@Component({
    selector: 'StudentGradebookComponent',
    templateUrl: './student-gradebook.component.html',
    providers: [StatusFormatterPipe],
    styleUrls: ['../assessments/student-classroom-assessments.component.css'],
    standalone: false
})
export class StudentGradebookComponent implements OnInit {
  searchText = ''
  showAssessmentTypeDropdown = false
  assessmentTypeSelected = AssessmentTypes.all_types;
  examService = inject(ExamService);
  myGrades: any[] = []

  currentPagination: Pagination = {
    limit: 15,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }

  ngOnInit(): void {
    this.handleGradeAPI()
  }

  handleGradeAPI() {
    this.examService.listClassroomGrades(this.currentPagination.page, this.currentPagination.limit, this.searchText).subscribe((response) => {
      if(response.success) {
        this.myGrades = response.result;
      }
    })
  }

  switchAssessmentTypeSelected(type: AssessmentTypes) {
    this.assessmentTypeSelected = type;
    switch(type) {
      case(AssessmentTypes.all_types):
        // TODO filter based on type here
        break;
      case(AssessmentTypes.exam):
        break;
      case(AssessmentTypes.quiz):
        break;
      case(AssessmentTypes.homework):
    }
    this.showAssessmentTypeDropdown = false
  }

  protected readonly faMagnifyingGlass = faMagnifyingGlass;
  protected readonly faChevronDown = faChevronDown;
  AssessmentTypes = AssessmentTypes;
}
